<div class="session-indicator" *ngIf="1 === 1">
  <div class="session-circle" [ngClass]="{'active': sessionQuery.isSessionStarted() | async}"></div>
  <div class="session-circle" [ngClass]="{'active': sessionQuery.isExerciseStarted() | async}"></div>
  <div class="session-circle" [ngClass]="{'active': sessionQuery.isLogging() | async}"></div>
  <div class="session-circle" [ngClass]="{'active': sessionQuery.isUploading() | async}"></div>
</div>
